<div class="header-navigation-back">
  <mat-icon (click)="onNavigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
  <span class="title">Shipment Document</span>
  
</div>
@if (!loading) {
  <div class="container">
    <div class="margin-bottom-md document-info-row">
      @if (!(document.role === 'Driver' && (document.type === 'ACEeManifest' || document.type === 'ACIeManifest'))) {
        <div fxFlex="40">{{ document?.typeDisplayName || '-' }}</div>
      }
      @if (document.role === 'Driver' && (document.type === 'ACEeManifest' || document.type === 'ACIeManifest')) {
        <div fxFlex="40">Stamped {{ document?.typeDisplayName || '-' }}</div>
      }
      @if (!isReadOnlyDocument) {
        <div>
          <button class="btn-download" (click)="openActionSheet()" data-test="action-button">
            Actions
          </button>
        </div>
      }
    </div>
    @if (previewImage) {
      <img [src]="previewImage" class="imagePreview padding-md" data-test="preview-image" />
    }
    @if (safeUrl) {
      <iframe
        [src]="safeUrl"
        class="safeUrl"
        frameborder="0"
        loading="lazy"
        class="iframe"
        data-test="preview-document"
      ></iframe>
    }
  </div>
}
